import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsuarioPermissaoEdicaoComponent } from './usuario-permissao-edicao/usuario-permissao-edicao.component';
import { UsuarioPermissaoListaComponent } from './usuario-permissao-lista/usuario-permissao-lista.component';


const routes: Routes = [
  { path: 'usuarioPermissao/listar', component: UsuarioPermissaoListaComponent, data: { titulo: 'Lista as Permissões de Usuários' }  },
  { path: 'usuarioPermissao/novo', component: UsuarioPermissaoEdicaoComponent, data: { titulo: 'Nova Permissão de Usuário' } },
  { path: 'usuarioPermissao/edicao/:id', component: UsuarioPermissaoEdicaoComponent, data: { titulo: 'Edição de Permissões de Usuários' }  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class UsuarioPermissaoRoutingModule { }
